import React, { Fragment, useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import useRequests from "../../../utils/useRequests";
import Snackbars from "../../../utils/Snackbars";
import { Col, Card, Form, Spinner, Modal, Button } from "react-bootstrap";
import DataTable from "react-data-table-component";

function Widget({ number, title }) {
	return (
		<div className="media-body">
			<h2 className="fs-38 text-black font-w600">{number}</h2>
			<span className="fs-18">{title}</span>
		</div>
	)
}
const EventDetails = () => {
  const { e_id } = useParams();
  const [loading, setLoading] = useState(true);
  const { getRequest, postRequest } = useRequests();
  const [detail, setDetail] = useState({
    first_name: "",
    last_name: "",
    name: "",
    city: "",
    address: "",
    start_datetime: "",
    end_datetime: "",
    status: "Enable",
    short_description: "",
    banner: "",
    general_tp: "",
    vip_tp: "",
    vvip_tp: "",
    total_tickets: ""
  });
  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: ""
  });
  const [eventPurchases, setEventPurchases] = useState([]);
  const [eventTotalPrice, setEventTotalPrice] = useState(0);
  const [eventTotalQuantity, setEventTotalQuantity] = useState(0);

  const formatTwo = (v) => {
    const n = Number(v);
    if (!isFinite(n)) return '0.00';
    return n.toFixed(2);
  };

  function formatDateTime(dateString) {
    const date = new Date(dateString); // Convert to Date object

    // Extract the date components
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    // Extract the time components
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12; // Convert 24-hour time to 12-hour format

    // Format the date and time
    return `${day}/${month}/${year} | `;
  }

  const formattedStartDate = formatDateTime(detail.start_datetime);
  const formattedEndDate = formatDateTime(detail.end_datetime);

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: ""
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };
  const [tickets, setTickets] = useState([])
  const [remainingtickets, setRemainingTickets] = useState(0)
  const [ticketFilter, setTicketFilter] = useState('all');
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [statusEditingTicket, setStatusEditingTicket] = useState(null);
  const [newStatus, setNewStatus] = useState('ACTIVE');

  const normalizeStatus = (s) => {
    if (!s) return 'ACTIVE';
    const up = String(s).trim().toUpperCase();
    if (up === 'ENABLE' || up === 'ENABLED') return 'ACTIVE';
    if (up === 'SOLDOUT' || up === 'SOLD_OUT') return 'SOLD OUT';
    if (up.includes('SOLD')) return 'SOLD OUT';
    if (up.includes('COMING')) return 'COMING SOON';
    if (up === 'ACTIVE') return 'ACTIVE';
    return up;
  };

  const openStatusModal = (row) => {
    setStatusEditingTicket(row);
    setNewStatus(normalizeStatus(row.day_status || row.status));
    setShowStatusModal(true);
  };

  const submitStatusChange = async () => {
    if (!statusEditingTicket) {
      setShowStatusModal(false);
      return;
    }

    // determine ticket-type id to send to API
    const e_t_id = statusEditingTicket.e_t_id || statusEditingTicket.id || statusEditingTicket.eid || statusEditingTicket.ticket_type_id || statusEditingTicket.event_ticket_type_id || statusEditingTicket.type_id || null;
    if (!e_t_id) {
      setAlertData({ variant: 'error', message: 'Unable to determine ticket id for status update' });
      resetAlertData();
      return setShowStatusModal(false);
    }

    try {
      const payload = JSON.stringify({ e_t_id: e_t_id, status: newStatus });
      const res = await postRequest('change-ticket-type-status', payload);
      if (res && res.code === 200) {
        // update local tickets state to reflect server change
        setTickets(prev => prev.map(t => {
          const tkey = t.e_t_id || t.id || t.eid || t.ticket_type_id || t.event_ticket_type_id || t.type_id || null;
          if (tkey !== null && String(tkey) === String(e_t_id)) {
            return { ...t, day_status: newStatus };
          }
          return t;
        }));
        setStatusEditingTicket(prev => prev ? { ...prev, day_status: newStatus } : prev);
        setAlertData({ variant: 'success', message: res.message || 'Status updated' });
        resetAlertData();
      } else {
        setAlertData({ variant: 'error', message: res ? res.message : 'Failed to update status' });
        resetAlertData();
      }
    } catch (err) {
      console.error('status update error', err);
      setAlertData({ variant: 'error', message: err.message || 'Failed to update status' });
      resetAlertData();
    } finally {
      setShowStatusModal(false);
    }
  };
  const fetchEventDetails = async () => {
    setLoading(true); // Set loading state to true
    const response = await getRequest(`event-details/${e_id}`);
    if (response && response.code === 200) {
      const data = response.data;
      setTickets(data.eventTicketTypeData)
      let remainingtickets=0;
      data.eventTicketTypeData.forEach(element => {
        remainingtickets+= (element.total_tickets - element.assigned_tickets);
      });
      setRemainingTickets(remainingtickets);

      setDetail({
        first_name: data.first_name,
        last_name: data.last_name,
        name: data.name,
        city: data.city,
        address: data.address,
        start_datetime: data.start_datetime,
        end_datetime: data.end_datetime,
        start_time: data.start_time,
        end_time: data.end_time,
        short_description: data.short_description,
        status: data.status,
        general_tp: data.general_tp,
        vip_tp: data.vip_tp,
        vvip_tp: data.vvip_tp,
        total_tickets: data.total_tickets,
        banner: data.logo
      });
      // fetch purchases and compute totals for this event
      try {
        const pr = await getRequest('purchase-tickets');
        if (pr && pr.code === 200 && Array.isArray(pr.data)) {
          const all = pr.data;
          const matches = all.filter(p => {
            // tolerant matching for event id
            return String(p.event_id) === String(e_id) || String(p.e_id) === String(e_id) || String(p.event) === String(e_id) || String(p.event_eid) === String(e_id);
          });
          setEventPurchases(matches);
          const totalPrice = matches.reduce((acc, p) => acc + Number(p.purchase_price || p.price || 0), 0);
          const totalQty = matches.reduce((acc, p) => acc + Number(p.quantity || p.qty || p.ticket_quantity || 0), 0);
          setEventTotalPrice(totalPrice);
          setEventTotalQuantity(totalQty);
            // Compute ticket_sales per ticket type (sum of purchase_price grouped by e_t_id)
            try {
              const ticketSalesMap = {};
              matches.forEach(p => {
                const key = p.e_t_id || p.event_ticket_type_id || p.ticket_type_id || p.ticket_type || p.event_ticket_type || p.e_ticket_type_id || p.e_t || null;
                if (key === undefined || key === null) return;
                const sk = String(key);
                const price = Number(p.purchase_price || p.price || 0) || 0;
                ticketSalesMap[sk] = (ticketSalesMap[sk] || 0) + price;
              });

              // Attach ticket_sales to ticket entries returned from API
              const enrichedTickets = (data.eventTicketTypeData || []).map(t => {
                const tkey = t.e_t_id || t.id || t.eid || t.ticket_type_id || t.event_ticket_type_id || t.type_id || null;
                const st = tkey === null ? null : String(tkey);
                return {
                  ...t,
                  ticket_sales: st && ticketSalesMap[st] ? ticketSalesMap[st] : 0
                };
              });
              setTickets(enrichedTickets);
            } catch (err) {
              console.error('ticket sales calc error', err);
            }
        }
      } catch (err) {
        // ignore purchase fetch errors for now
        console.error('purchase-tickets fetch error', err);
      }
    } else {
      setAlertData({ variant: "error", message: response.message || "Failed to fetch event details" });
    }
    setLoading(false); // Set loading state to false
    resetAlertData();
  };

        const columns = [
                {
                  name: "Ticket Type",
                  selector: (row) => row.type,
                  sortable: true,
                  width:'350px'
                  // whiteSpace:'normal !important'
                },
                {
                  name: "Day Type",
                  selector: (row) => row.day_pass+ " Day",
                  sortable: true,
                  width:"200px"
                },
                 {
                  name: "Ticket Price",
                  selector: (row) => "Rs "+row.price,
                  sortable: true,
                  width:"200px"
                },
                {
                  name: "Total Tickets Sold",
                  selector: (row) => row.assigned_tickets,
                  sortable: true,
                  width:"200px"
                },
                
                {
                  name: "Total Tickets Remaining",
                  selector: (row) => row.total_tickets - row.assigned_tickets,
                  sortable: true,
                  width:"250px"
                },
                {
                  name: "Total Tickets Sales",
                  selector: (row) => "RS "+formatTwo(row.ticket_sales),
                  sortable: true,
                  width:"200px"
                },
                {
                  name: "Status",
                  cell: (row) => (
                  <button
                    className={`btn ${row.day_status && row.day_status.toLowerCase() !== "sold out" ? "btn-success" : "btn-danger"} btn-xxs`}
                    onClick={() => openStatusModal(row)}
                  >
                    {(row.day_status || '').toUpperCase()}
                  </button>
                  ),
                  center: true,
                  width: "200px",
                },
              ];

                const transactionColumns = [
                {
                  name: "Ticket Type",
                  selector: (row) => row.type,
                  sortable: true,
                  width:'400px'
                  // whiteSpace:'normal !important'
                },
                {
                  name: "Mobile Number",
                  selector: (row) => row.phone,
                  sortable: true,
                  width:'400px'
                  // whiteSpace:'normal !important'
                },
                {
                  name: "Purchase Price",
                  selector: (row) => "Rs "+row.purchase_price,
                  sortable: true,
                  width:"200px"
                },

                {
                name: "Date",
                selector: (row) => {
                    const date = new Date(row.purchase_date);
                    const formattedDate = date.toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    });
                    const formattedTime = date.toLocaleTimeString("en-GB", {
                    hour: "2-digit",
                    minute: "2-digit",
                    });
                    return `${formattedDate}`;
                },
                sortable: true,
                width: "150px" 
                },
                {
                  name: "No. of Tickets",
                  selector: (row) => row.quantity,
                  sortable: true,
                  width:"250px"
                },
                {
                  name: "Payment Id",
                  selector: (row) => row.payment_id,
                  sortable: true,
                  width:"200px"
                },
              ];

                  const customStyles = {
    header: {
        style: {
          whiteSpace:"normal",
        // minHeight: "56px",
        // flexBasis:'auto !important',
        },
    },
    headCells: {
        style: {
        // flexBasis:'auto !important',
        color: "#341439",
        fontSize: "17px",
        fontWeight: "600",
        textTransform: "capitalize",
        paddingLeft: "8px", // Adjust padding
        paddingRight: "8px",
        },
    },
    cells: {
        style: {
        // flexBasis:'auto !important',
        fontSize: "16px",
        padding: "12px 9px",
        color: "#7E7E7E",
        
        },
    },
    pagination: {
        style: {
        fontSize: "16px",
        },
    },
    "& .hmVlQg div:first-child": {
    whiteSpace: "normal !important",
},
    };

  useEffect(() => {
    fetchEventDetails();
  }, []);

  return (
    <Fragment>
      <div className="d-sm-flex d-block justify-content-between align-items-center mb-4">
        <h2 className="text-black font-w600 mb-0"> Event Analytics : {detail.name}</h2>
        {AlertData.message !== "" ? (
          <Snackbars variant={AlertData.variant} message={AlertData.message} />
        ) : (
          ""
        )}
        <Link to="/analytics" type="button" className="btn btn-rounded btn-primary">
          Back
        </Link>
      </div>
      {!loading && (
        <div className="row mb-3">
                <div className="col-xl-4 col-sm-6">
					<div className="card">
						<div className="card-body">
							<div className="media align-items-center">
								<Widget number={` ${eventTotalQuantity}`}  title="Total Tickets Sold" />
								<span className="p-3 border ms-3 rounded-circle">
								<i class="fas fa-ticket-alt"></i>
								</span>
							</div>
						</div>
					</div>
				</div>
                <div className="col-xl-4 col-sm-6">
					<div className="card">
						<div className="card-body">
							<div className="media align-items-center">
								<Widget number={` ${remainingtickets}`}  title="Total Tickets Remaining" />
								<span className="p-3 border ms-3 rounded-circle">
								<i class="fas fa-ticket-alt"></i>
								</span>
							</div>
						</div>
					</div>
				</div>
                <div className="col-xl-4 col-sm-6">
					<div className="card">
						<div className="card-body">
							<div className="media align-items-center">
								<Widget number={`Rs ${formatTwo(eventTotalPrice)}`}  title="Total Tickets Sales" />
								<span className="p-3 border ms-3 rounded-circle">
								<i class="far fa-money-bill-alt"></i>
								</span>
							</div>
						</div>
					</div>
				</div>
        </div>
        // <div className="mb-3 d-flex gap-3">
        //   <div className="badge bg-light p-3">
        //     <div className="fs-14 text-muted">Total Tickets Sold</div>
        //     <div className="fs-18 font-w600">{eventTotalQuantity}</div>
        //   </div>
        //   <div className="badge bg-light p-3">
        //     <div className="fs-14 text-muted">Total Ticket Sales</div>
        //     <div className="fs-18 font-w600">Rs {formatTwo(eventTotalPrice)}</div>
        //   </div>
        // </div>
      )}

      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="primary" />
          <p>Loading Event Analytics...</p>
          
        </div>
      ) : (
        
        <div className="col-lg-12">
                    <Col lg={12}> 
                    <Card>
                      <Card.Body>
                        {loading ? (
                          <div className='text-center'>
                            <Spinner animation='border'variant="primary"  />
                            <p>Loading Analytics...</p>
                          </div>
                        ) : (
                          <DataTable
                            columns={columns}
                            data={tickets} // Use filtered data
                            customStyles={customStyles}
                            pagination
                            highlightOnHover
                            responsive
                          />
                        )}
                      </Card.Body>
                    </Card>
                    </Col>

                    <Col lg={12}> 
                    <Card>
                      <Card.Body>
                        {loading ? (
                          <div className='text-center'>
                            <Spinner animation='border'variant="primary"  />
                            <p>Loading Analytics...</p>
                          </div>
                        ) : (
                          <>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <h5 className="mb-0">Transactions</h5>
                              <div style={{minWidth: '18rem'}}>
                                
                                <Form.Select
                                  aria-label="Filter by ticket type"
                                  value={ticketFilter}
                                  onChange={(e) => setTicketFilter(e.target.value)}
                                  style={{width: '100%'}}
                                >
                                  <option value="all">All Ticket Types</option>
                                  {tickets && tickets.map((t, i) => {
                                    const tkey = t.e_t_id || t.id || t.eid || t.ticket_type_id || t.event_ticket_type_id || t.type_id || String(i);
                                    return (
                                      <option key={i} value={String(tkey)}>{`${t.type || 'Ticket'}${t.day_pass ? ` (${t.day_pass} day)` : ''}`}</option>
                                    )
                                  })}
                                </Form.Select>
                              </div>
                            </div>
                            <DataTable
                              columns={transactionColumns}
                              data={
                                ticketFilter === 'all'
                                  ? eventPurchases
                                  : eventPurchases.filter(p => {
                                      const pk = p.e_t_id || p.event_ticket_type_id || p.ticket_type_id || p.ticket_type || p.event_ticket_type || p.e_ticket_type_id || p.e_t || null;
                                      return pk !== undefined && pk !== null && String(pk) === String(ticketFilter);
                                    })
                              }
                              customStyles={customStyles}
                              pagination
                              highlightOnHover
                              responsive
                            />
                          </>
                        )}
                      </Card.Body>
                    </Card>
                    </Col>
        </div>
      )}
      {/* Status edit modal */}
      <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Ticket Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Select Status</Form.Label>
            <Form.Select value={newStatus} onChange={(e) => setNewStatus(e.target.value)}>
              <option value="ACTIVE">ACTIVE</option>
              <option value="COMING SOON">COMING SOON</option>
              <option value="SOLD OUT">SOLD OUT</option>
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowStatusModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={submitStatusChange}>Submit</Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default EventDetails;
